import React from 'react';
import { Switch } from 'react-router-dom';
import { DefaultLayout } from '../layouts/default';
import { Dashboard } from '../pages/Dashboard';
import { SignIn } from '../pages/Auth/SignIn';
import { RecoveryPassword } from '../pages/Auth/RecoveryPassword';
import { Users } from '../pages/Users';
import Route from './Route';
import { AuthLayout } from '../layouts/auth';
import { ForgotPassword } from '../pages/Auth/ForgotPassword';
import { SignUp } from '../pages/Auth/SignUp';
import { FormUser } from '../pages/Users/Form';
import { ConfirmMail } from '../pages/Auth/ConfirmMail';
import { Campaign } from '../pages/Campaign';
import { FormCampaign } from '../pages/Campaign/Form';
import { Influencers } from '../pages/Influencers';
import { FormInfluencer } from '../pages/Influencers/Form';
import { Clients } from '../pages/Clients';
import { FormClient } from '../pages/Clients/Form';
import { ReportInfluencer } from '../pages/Influencers/Report';
import { ReportCampaign } from '../pages/Campaign/Report';
import { Twitch } from '../pages/Twitch';

export const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact layout={AuthLayout} component={SignIn} />
    <Route path="/auth/signup" layout={AuthLayout} component={SignUp} />
    <Route
      path="/auth/confirmEmail"
      layout={AuthLayout}
      component={ConfirmMail}
    />
    <Route
      path="/auth/recovery"
      layout={AuthLayout}
      component={RecoveryPassword}
    />
    <Route path="/auth/forgot" layout={AuthLayout} component={ForgotPassword} />
    <Route
      path="/dashboard"
      layout={DefaultLayout}
      roles={['ADMIN', 'USER', 'CLIENT']}
      isPrivate
      component={Dashboard}
    />
    <Route
      path="/users"
      layout={DefaultLayout}
      roles={['ADMIN']}
      isPrivate
      exact
      component={Users}
    />
    <Route
      path="/users/new"
      layout={DefaultLayout}
      roles={['ADMIN']}
      isPrivate
      component={FormUser}
    />
    <Route
      path="/users/:id"
      layout={DefaultLayout}
      roles={['ADMIN']}
      isPrivate
      component={FormUser}
    />
    <Route
      path="/clients"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={Clients}
    />
    <Route
      path="/clients/new"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      component={FormClient}
    />
    <Route
      path="/clients/:id"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      component={FormClient}
    />
    <Route
      path="/campaigns"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={Campaign}
    />
    <Route
      path="/campaigns/new"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={FormCampaign}
    />
    <Route
      path="/campaigns/:id"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={FormCampaign}
    />
    <Route
      path="/campaigns/:id/report"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={ReportCampaign}
    />
    <Route
      path="/influencers"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={Influencers}
    />
    <Route
      path="/influencers/new"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={FormInfluencer}
    />
    <Route
      path="/influencers/:id"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={FormInfluencer}
    />
    <Route
      path="/influencers/:id/report"
      layout={DefaultLayout}
      roles={['ADMIN', 'CLIENT']}
      isPrivate
      exact
      component={ReportInfluencer}
    />
    <Route path="/twitch/auth" exact component={Twitch} />
  </Switch>
);
